import { createSelector } from 'reselect';
import { RootState } from '../store.types';
import { RostersState } from './models';



export const selectRostersState = (state: RootState): RostersState => (state.rosters);

export const selectRosterList = createSelector(
  selectRostersState,
  (state: RostersState) => state.rosterList ? state.rosterList : []
);

export const selectRostersLoading = createSelector(
  selectRostersState,
  (state: RostersState) => state.loading
);

export const selectRostersLoaded = createSelector(
  selectRostersState,
  (state: RostersState) => state.loaded
);

export const selectRostersErrMsg = createSelector(
  selectRostersState,
  (state: RostersState) => state.errMsg
);